import { computed, ref } from 'vue'
import { defineStore, type StateTree } from 'pinia'

const useConsentStore = defineStore(
    'consent',
    () => {
        const instagramEnabled = ref(false)
        const spotifyEnabled = ref(false)
        const youtubeEnabled = ref(false)
        const domainsEnabled = ref<Set<string>>(new Set())

        const domainEnabled = (domain: string) => {
            return computed(() => {
                return domainsEnabled.value.has(domain)
            })
        }

        const enableDomain = (domain: string) => {
            console.log('enabling', domain)
            domainsEnabled.value.add(domain)
        }

        return {
            instagramEnabled,
            spotifyEnabled,
            youtubeEnabled,
            domainsEnabled,
            domainEnabled,
            enableDomain,
        }
    },
    {
        persist: {
            serializer: {
                deserialize: (data: string) => {
                    const parsed = JSON.parse(data)
                    // Convert arrays back to Sets
                    if (
                        parsed.domainsEnabled &&
                        Array.isArray(parsed.domainsEnabled)
                    ) {
                        parsed.domainsEnabled = new Set(parsed.domainsEnabled)
                    }
                    return parsed
                },
                serialize: (value: StateTree) => {
                    const serializable = { ...value }
                    // Convert Sets to arrays for JSON serialization
                    if (serializable.domainsEnabled instanceof Set) {
                        serializable.domainsEnabled = Array.from(
                            serializable.domainsEnabled
                        ) as any
                    }
                    return JSON.stringify(serializable)
                },
            },
        },
    }
)

export default useConsentStore
